import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CryPayGatHero from "./CryPayGatHero";
import CryPayIndustry from "./CryPayIndustry";
import CryPayGatDev from "./CryPayGatDev";
import HighlightsOfOurCry from "./HighlightsOfOurCry";
import StartAccepting from "./StartAccepting";
import InstantConversion from "./InstantConversion";
import BlockchainExpertise from "../../AMM DEX/BlockchainExpertise";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function CryptoPaymentGateway() {
  return (
    <div>
      <Header />
      <CryPayGatHero />
      <CryPayIndustry />
      <CryPayGatDev />
      <HighlightsOfOurCry />
      <StartAccepting />
      <InstantConversion />
      {/* <BlockchainExpertise /> */}
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default CryptoPaymentGateway;
